import api from '../../../core/api/client';

export const memberApprovalService = {
  async getPendingApprovals() {
    try {
      const response = await api.get('/member-approvals');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getPendingMembers() {
    return this.getPendingApprovals();
  },

  async approveMember(pendingId) {
    try {
      const response = await api.post(`/member-approvals/${pendingId}/approve`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async rejectMember(pendingId) {
    try {
      const response = await api.post(`/member-approvals/${pendingId}/reject`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
